import { db } from '../firebase/config';
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  query,
  orderBy,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';

const CONTACT_COLLECTION = 'contacts';

// EXISTING: submit a contact form (used by Contact.jsx)
export const submitContactForm = async (formData) => {
  try {
    const docRef = await addDoc(collection(db, CONTACT_COLLECTION), {
      ...formData,
      status: 'new',
      createdAt: serverTimestamp(),
    });
    return { id: docRef.id, ...formData };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw new Error('Failed to submit contact form. Please try again.');
  }
};

// NEW: fetch all contact messages (admin only)
export const getContacts = async () => {
  const q = query(
    collection(db, CONTACT_COLLECTION),
    orderBy('createdAt', 'desc')
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

// NEW: mark a message as read
export const markContactAsRead = async (id) => {
  await updateDoc(doc(db, CONTACT_COLLECTION, id), { status: 'read' });
};

// NEW: delete a message
export const deleteContact = async (id) => {
  await deleteDoc(doc(db, CONTACT_COLLECTION, id));
};